export const INTEGRATION_MODES = {
  dedicated: 'dedicated',
  shared: 'shared',
};